import styles from './PageHeader.module.css';

import type { ReactNode } from 'react';

export interface PageHeaderProps {
  readonly eyebrow: string;
  readonly title: string;
  readonly subtitle?: ReactNode;
  readonly actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, subtitle, actions }: PageHeaderProps) {
  return (
    <header className={styles.header}>
      <div>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}
